import styled from 'styled-components';

const FlexWrapper = styled.div`
  // display: flex;
  padding-left: 20%;
  padding-right: 20%;
`;

export default FlexWrapper;
